import Vue from 'vue'
import Store from 'store'

import CheckoutLine from './CheckoutLine.vue'

const el = '.nti-component--checkout-line'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                CheckoutLine
            },
            template: '<CheckoutLine />'
        })
    }
}

export default {
    render
}